import { Injectable, OnInit, ViewChild } from "@angular/core";
import { CardTableComponent } from "src/app/components/cards/card-table/card-table.component";
import { ListAction } from "src/app/models/list-actions.model";
import { ListColumn } from "src/app/models/list-columns.model";
import { AlertasSwalService } from "src/app/services/alerts.service";
import Swal from "sweetalert2";
import { CrudForm } from "./crud.form";
import { CrudService } from "./crud.service";

@Injectable()
export abstract class CrudComponent<T> {
  abstract columnId: string;
  protected columnActive: string = "Activo";
  protected useFilterInactive: boolean = false;
  public columns: ListColumn[] = [
    {
      name: "Nombre",
      property: "Nombre",
      visible: true,
    },
    {
      name: "actions",
      property: "actions",
      visible: true,
    },
  ];
  public actions: ListAction<T>[] = [
    {
      desc: "Actualizar",
      action: "update",
      visible: () => true,
      icon: "far fa-edit",
      color: "text-blue-600",
    },
    {
      desc: "Eliminar",
      action: "remove",
      visible: (row) => row[this.columnActive],
      color: "text-red-600",
      icon: "far fa-trash-alt",
    },
    {
      desc: "Activar",
      action: "activate",
      visible: (row) => !row[this.columnActive],
      icon: "far fa-check-circle",
      color: "text-green-600",
    },
  ];

  @ViewChild(CardTableComponent, { static: true })
  public tableComp: CardTableComponent;

  @ViewChild("formulario")
  public formulario: CrudForm<T>;

  public showInactive: boolean = false;

  constructor(public service: CrudService<T>, public alerts: AlertasSwalService) {}

  Init(): void {
    this.preLoadRecords();
    this.loadRecords();
    this.postLoadRecords();
  }
  preLoadRecords() {
    return;
  }
  postLoadRecords() {
    return;
  }

  openEdit(value: T){
    return;
  }

  loadRecords() {
    let filterActive = "1";
    if (this.useFilterInactive) {
      filterActive = this.showInactive ? "0" : "1";
    }

    this.service.get(filterActive).subscribe(
      (resultData) => {
        this.tableComp.setData(resultData);
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  }

  saveForm(e: { mode: string; value: T }) {
    if (e.mode == "create") {
      this.guardar(e.value);
    } else if (e.mode == "update") {
      this.actualizar(e.value);
    }
  }

  actionstable(e: { action: string; row: T }) {
    if (e.action == "update") {
      this.openEdit(e.row);
      this.formulario.setUpdate(e.row);
    } else if (e.action == "activate") {
      this.activar(e.row);
    } else if (e.action == "remove") {
      this.askRemove(e.row);
    }
  }
  guardar(row: T) {
    this.service.add(row).subscribe(
      (next) => {
        this.alerts.correcta("Creado", "Accion realizada correctamente");
        this.formulario.setStanby();
        this.loadRecords();
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      },
      () => {
        this.formulario.setWaiting(false);
      }
    );
  }
  actualizar(row: T) {
    this.service.update(row).subscribe(
      (next) => {
        this.alerts.correcta("Actualizado", "Accion realizada correctamente");
        this.formulario.setStanby();
        this.loadRecords();
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  }
  askRemove(row: T) {
    Swal.fire({
      title: "Seguro que quieres eliminar este registro?",
      text: "Esta accion es irreversible!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.isConfirmed) {
        this.eliminar(row);
      }
    });
  }

  eliminar(row: T) {
    this.service.delete(row[this.columnId]).subscribe(
      (next) => {
        this.alerts.correcta("Eliminado", "Accion realizada correctamente");
        this.loadRecords();
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  }

  activar(row: T) {
    this.service.activate(row[this.columnId]).subscribe(
      (next) => {
        this.alerts.correcta("Activado", "Accion realizada correctamente");
        this.loadRecords();
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  }

  public checkboxChange() {
    this.loadRecords();
  }
}
